{
  "randevu": {
    "Randevular": "Afspraken",
    "Randevu Ekle": "Afspraak toevoegen",
    "Randevu": "Afspraak",
    "Müşteri": "Klant",
    "Tarih": "Datum",
    "Başlama Saat": "Begintijd",
    "Bitiş Saat": "Eindtijd",
    "Görüşme": "Vergadering",
    "Not": "Opmerking",
    "Ulaşım": "Vervoer",
    "Görüşmeye Katılanlar": "Deelnemers",
    "Görüşme Sonuç": "Resultaat vergadering",
    "Tekrar Tarih": "Herhaaldatum",
    "Tekrar Başlama Saat": "Herhaal begintijd",
    "Tekrar Bitiş Saat": "Herhaal eindtijd",
    "Randevu Bilgi": "Afspraakinformatie",
    "Onay Bekliyor": "Wacht op goedkeuring",
    "Saat Kontrol": "Tijdcontrole"
  }
}
